<template>
  <div>
    <ts-page-title
      :title="$t('levelSkill.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('levelSkill.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end">
          <a-input
            v-model="search"
            v-tooltip="$t('levelSkill.search')"
            :placeholder="$t('levelSkill.search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="tw-whitespace-nowrap">{{ record.level_skill_name }}</td>
            <td class="tw-whitespace-nowrap">
              {{ record.skill_name_en }}
              <span
                v-if="record.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.skill_name_kh }}
              <span
                v-if="record.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.skill_level_order }}
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('levelSkill.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="900px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FromAction from "./form.vue";
export default {
  name: "levelSkillIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("academic/levelSkill", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.levelSkill.search;
      },
      set(newValue) {
        this.$store.commit("academic/levelSkill/SET_SEARCH", newValue);
        this.$store.commit("academic/levelSkill/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        {
          name: this.$t("levelSkill.levelSkillName"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkill.skillEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkill.skillKh"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkill.skillLevelOrder"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/levelSkill/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit("academic/levelSkill/SET_EDIT_DATA", record);
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("academic/levelSkill/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("academic/levelSkill/destroy", record.level_skill_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/levelSkill/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
